var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGripLines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.546,
    height: 14.546,
    viewBox: "0 0 14.546 14.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "grip-lines-solid",
    d: "M1.286,160a1.286,1.286,0,1,0,0,2.571H16.714a1.286,1.286,0,1,0,0-2.571Z",
    transform: "translate(-113.137 -100.409) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripLines);
export default __webpack_public_path__ + "static/media/grip-lines.935f42944f3e619f2b37c7365fde1782.svg";
export { ForwardRef as ReactComponent };